import axios from './axios.js'
let query_header = {
  'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
}
let json_headers = {
  'Content-Type': 'application/json'
}
// /test/api/yueyilan
const api = {
  //首页
  getHome(){
    return axios({
      url:'/official/main',
      method: 'get'
    })
  },
  //集团信息/集团部门
  getCompanyInfo(params){
    return axios({
      url:'/official/group',
      method: 'get',
      params:params
    })
  },
  //集团信息/集团部门
  getNews(params){
    return axios({
      url:'/official/news',
      method: 'get',
      params:params
    })
  },
  //详情
  getXq(params){
    return axios({
      url:'/official/news/'+params.id,
      method: 'get'
    })
  }
}

export default api



// WEBPACK FOOTER //
// ./src/api/api.js